export default __webpack_public_path__ + "static/media/defectPercentage.4459f7ed.svg";